import { configFetch } from "@origin-digital/daxi";

const env = (window as any)["oetal"].env.name;

const disableAuthCheck = ["local", "dev"].includes(env);

configFetch({
  environment: env,
  disableAuthCheck: disableAuthCheck
});
